import { ControlAttributeType, } from "../../../../form/typings";
import { formatterValueToSetStatus } from "../../../../form/utils";
import baseAttribute from "../../../../form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name"],
        },
        controller: {
            label: "控制属性",
            keys: ["displayFormula"],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: "描述" }),
        // 显示条件
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
    },
};
